import { XMarkIcon } from '@heroicons/react/24/solid';
import type { TextInputProps } from '@mantine/core';
import { ActionIcon, TextInput } from '@mantine/core';
import React, { useState } from 'react';

import styles from './TextField.module.css';

export const LBTextField = React.forwardRef<
  React.ElementRef<typeof TextInput>,
  TextInputProps
>(({ value, onChange, ...props }, ref) => {
  const [inputValue, setInputValue] = useState(value);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInputValue(e.target.value);
    if (onChange) onChange(e);
  };

  const clearValue = () => {
    setInputValue('');
    if (onChange)
      onChange({
        target: { value: '' }
      } as React.ChangeEvent<HTMLInputElement>);
  };

  return (
    <TextInput
      {...props}
      ref={ref}
      classNames={styles}
      inputWrapperOrder={['label', 'input', 'error', 'description']}
      rightSectionPointerEvents='all'
      value={inputValue}
      rightSection={
        <ActionIcon color='gray' variant='subtle' onClick={clearValue}>
          <XMarkIcon className={styles.icon} />
        </ActionIcon>
      }
      onChange={handleChange}
    />
  );
});
